var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"return-button-container"},[_c('ReturnButton',{attrs:{"to":_vm.to}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }